import React from 'react';

import OutsideClickWrapper from 'Components/hoc/OutsideClickWrapper/OutsideClickWrapper';
import UDropdownBox from 'Components/unit/UDropdownBox/UDropdownBox';
import UDropdownItem from 'Components/unit/UDropdownItem/UDropdownItem';
import UIconButton from 'Components/unit/UIconButton/UIconButton';

import styles from '../Item.styles';

interface OptionItem {
  title: string;
  color: string;
  callback: () => void;
}

interface ActivityOptionsProps {
  options: OptionItem[];
  isOptionOpen: boolean;
  wrapperRef: React.RefObject<HTMLDivElement>;
  handleOptionClick: (e: React.MouseEvent<Element>) => void;
  handleOutsideClick: (isOutsideClicked: boolean) => void;
  handleClickOption: (callback: () => void, activityId: number) => void;
  activityId: number;
}

const ActivityOptions: React.FC<ActivityOptionsProps> = ({
  options,
  isOptionOpen,
  wrapperRef,
  handleOptionClick,
  handleOutsideClick,
  handleClickOption,
  activityId,
}) => {
  const handleRenderItem = ({ title: optionTitle, color, callback }: OptionItem) => (
    <UDropdownItem
      key={optionTitle}
      text={optionTitle}
      color={color}
      onClick={() => {
        handleClickOption(callback, activityId);
      }}
      stopClickPropagation
    />
  );

  // Custom handler that adapts the event type for UIconButton
  const onClickIconHandler = (e: unknown) => {
    // Cast to the expected type for handleOptionClick
    handleOptionClick(e as React.MouseEvent<Element>);
  };

  return (
    <div ref={wrapperRef}>
      <UIconButton
        icon="options"
        data-test-id="options-menu"
        style={styles.iconOptions}
        onClick={onClickIconHandler}
        stopClickPropagation
        ghost
      />
      {isOptionOpen && (
        <OutsideClickWrapper
          onClick={(isOutsideClicked: boolean) => handleOutsideClick(isOutsideClicked)}
          data-test-id="outside-click-wrapper"
        >
          <UDropdownBox
            data-test-id="options-dropdown"
            items={options}
            renderItem={handleRenderItem}
            style={styles.dropdownBox}
          />
        </OutsideClickWrapper>
      )}
    </div>
  );
};

export default ActivityOptions;
